import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, QuoteIcon } from 'lucide-react';
export function TransformationSection() {
  const points = ['Enseñarle a competir con más calma, claridad y seguridad mental.', 'Ayudarlo a recuperarse mejor del error sin derrumbarse por dentro.', 'Acompañarlo desde casa con herramientas concretas, sin invadir ni meter más presión.', 'El fútbol vuelva a ser un espacio de crecimiento, no de sufrimiento constante.'];
  return <section className="py-16 md:py-24 bg-brand-green relative overflow-hidden" data-id="element-244">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-245"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-246">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto text-center mb-10 md:mb-16" data-id="element-247">
          <QuoteIcon className="w-12 h-12 text-brand-amber mx-auto mb-6 opacity-80" data-id="element-248" />
          <h3 className="text-2xl md:text-3xl font-heading text-white italic mb-4 flex flex-wrap justify-center gap-x-2" data-id="element-249">
            {'Si no intervienes ahora, la presión, el error y la frustración seguirán perjudicando su juego'.split(' ').map((word, i) => <motion.span key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.15
          }} data-id="element-250">
                  {word}
                </motion.span>)}
          </h3>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-251">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-252">
            <h2 className="text-3xl md:text-4xl font-heading text-white mb-6" data-id="element-253">
              Por eso creamos{' '}
              <span className="text-brand-amber" data-id="element-254">Competir sin Miedo</span>
            </h2>
            <p className="text-lg text-white/80 mb-8 leading-relaxed" data-id="element-255">
              Una guía práctica de fortaleza mental para futbolistas jóvenes y
              sus familias, diseñada para ayudarte a:
            </p>

            <ul className="space-y-5" data-id="element-256">
              {points.map((point, index) => <motion.li key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.2 + index * 0.1
            }} className="flex items-start" data-id="element-257">
                  <CheckCircle2Icon className="w-6 h-6 text-brand-amber flex-shrink-0 mr-3 mt-0.5" data-id="element-258" />
                  <span className="text-white/90 text-lg" data-id="element-259">{point}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-260">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl relative" data-id="element-261">
              <div className="absolute inset-0 bg-brand-green/20 mix-blend-multiply z-10" data-id="element-262"></div>
              <img src="https://cdn.magicpatterns.com/uploads/thWFT5rVF6Y9KdMETwdMpf/WhatsApp_Image_2026-04-01_at_19.32.35.jpg" alt="Joven futbolista compitiendo en partido" className="w-full h-full object-cover" loading="lazy" data-id="element-263" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-brand-green-dark to-transparent p-6 z-20" data-id="element-264">
                <p className="text-white font-medium text-lg" data-id="element-265">
                  Devuélvele la sonrisa en el campo.
                </p>
              </div>
            </div>

            {/* Decorative dots - hidden on mobile for performance */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-brand-amber/20 rounded-full blur-xl hidden md:block" data-id="element-266"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-brand-green-light/30 rounded-full blur-xl hidden md:block" data-id="element-267"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}